import { useSelector } from 'react-redux';
import * as spaceStore from 'screens/Space/store';

const useLibraryIds = () => {
  return useSelector(spaceStore.selectors.libraryIds);
};

export default useLibraryIds;
